<template>
  <v-container fluid>
    <v-layout column>
        <v-flex xs12>
          <h2 class=".display-1" dark>Kunden</h2>
        </v-flex>
        <v-flex xs12>
          <v-layout row>
            <v-text-field
              v-model="searchTerm"
              class="mx-1" label="Suche nach Nach-/Firmenname"
              prepend-inner-icon="search"
              solo
              clearable
            ></v-text-field>
            <v-btn dark
                   class="hidden-md-and-up"
                   @click="openNewDialog"
                   color="primary">
              <v-icon dark>person_add</v-icon>
            </v-btn>
            <v-btn depressed
                   medium
                   dark
                   class="hidden-sm-and-down"
                   @click="openNewDialog"
                   color="primary">
              Kunde Anlegen
              <v-icon right dark>person_add</v-icon>
            </v-btn>
          </v-layout>
        </v-flex>
    </v-layout>
    <v-layout row fill-height>
        <v-flex>
          <v-list
            id="customerList"
            two-line
            style="max-height: calc(100vh - 190px)"
            class="overflow-y-auto"
          >
            <v-flex
              v-scroll:#customerList="onScroll"
              align="center"
              justify="center"
            >
              <template v-for="(customer,index) in customers">
                <v-list-item v-if="index % 2 === 1"
                  :key="index" style="background-color: #B3E5FC40">
                  <v-list-item-action>
                    <v-icon medium v-if="customer.business">{{'business'}}</v-icon>
                    <v-icon medium v-if="!customer.business">{{'person'}}</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{customer.lastName}} {{customer.firstName}}</v-list-item-title>
                    <v-list-item-subtitle>{{customer.street}}</v-list-item-subtitle>
                    <v-list-item-subtitle>{{customer.zipCode}} {{customer.city}}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn text
                           icon
                           @click="openEditDialog(customer)"
                           color="primary">
                      <v-icon>edit</v-icon>
                    </v-btn>
                  </v-list-item-action>
                  <v-list-item-action>
                    <v-btn text
                           icon
                           @click="openDeleteDialog(customer)"
                           color="primary">
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
                <v-list-item v-else
                  :key="index">
                  <v-list-item-action>
                    <v-icon medium v-if="customer.business">{{'business'}}</v-icon>
                    <v-icon medium v-if="!customer.business">{{'person'}}</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{customer.lastName}} {{customer.firstName}}</v-list-item-title>
                    <v-list-item-subtitle>{{customer.street}}</v-list-item-subtitle>
                    <v-list-item-subtitle>{{customer.zipCode}} {{customer.city}}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn text
                           icon
                           @click="openEditDialog(customer)"
                           color="primary">
                      <v-icon>edit</v-icon>
                    </v-btn>
                  </v-list-item-action>
                  <v-list-item-action>
                    <v-btn text
                           icon
                           @click="openDeleteDialog(customer)"
                           color="primary">
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
                <v-divider
                  v-if="index + 1 < customers.length"
                  :key="'diviver-'+index"
                ></v-divider>
              </template>
            </v-flex>
          </v-list>
          <new-customer-dialog :show="showNewCustomerDialog" @close="closeNewDialog"></new-customer-dialog>
          <edit-customer-dialog :customer="selectedCustomer" :show="showEditCustomerDialog" @close="closeEditDialog"></edit-customer-dialog>
          <delete-customer-dialog :customer="selectedCustomer" :show="showDeleteCustomerConfirmDialog" @close="closeDeleteDialog"></delete-customer-dialog>
        </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import _ from 'lodash'
  import newCustomerDialog from './NewCustomerDialog'
  import editCustomerDialog from './EditCustomerDialog'
  import deleteCustomerConfirmDialog from './DeleteCustomerConfirmDialog'
  export default {
    name: 'Customers',
    data () {
      return {
        searchTerm: '',
        page: 0,
        size: 50,
        bottom: false,
        showNewCustomerDialog: false,
        showEditCustomerDialog: false,
        showDeleteCustomerConfirmDialog: false,
        selectedCustomer: {
          firstName: '',
          lastName: ''
        }
      }
    },
    components: {
      'new-customer-dialog': newCustomerDialog,
      'edit-customer-dialog': editCustomerDialog,
      'delete-customer-dialog': deleteCustomerConfirmDialog
    },
    computed: {
      customers: function () {
        return this.$store.getters.customers
      },
      maxCustomers: function () {
        return this.$store.getters.maxCustomers
      }
    },
    watch: {
      bottom (bottom) {
        if (bottom && this.customers.length < this.maxCustomers) {
          this.page++
          this.searchCustomers(this.searchTerm)
        }
      },
      searchTerm (searchTerm) {
        this.page = 0
        this.$store.dispatch('resetCustomers')
        if (searchTerm === null) {
          this.searchTerm = ''
          this.searchCustomers(this.searchTerm)
        } else {
          this.debouncedSearchCustomers(this.searchTerm)
        }
      }
    },
    created () {
      this.$store.dispatch('resetCustomers')
      this.debouncedSearchCustomers = _.debounce(this.searchCustomers, 500)
      this.searchCustomers(this.searchTerm)
    },
    methods: {
      searchCustomers: function (searchTerm) {
        this.$store.dispatch('loadCustomers', {
          searchTerms: searchTerm.split(' '),
          page: this.page,
          size: this.size
        })
      },
      onScroll: function (e) {
        const scrollY = e.target.scrollTop
        const visible = e.target.clientHeight
        const pageHeight = e.target.scrollHeight - 64.0 // window.scrollY not accurate on every device, we reduce the pageHeight by 15px
        const bottomOfPage = visible + scrollY >= pageHeight
        this.bottom = bottomOfPage || pageHeight < visible
      },
      openNewDialog: function () {
        this.showNewCustomerDialog = true
        this.resetSearch()
      },
      closeNewDialog: function () {
        this.showNewCustomerDialog = false
      },
      openEditDialog: function (customer) {
        this.selectedCustomer = customer
        this.showEditCustomerDialog = true
      },
      closeEditDialog: function () {
        this.showEditCustomerDialog = false
      },
      openDeleteDialog: function (customer) {
        this.selectedCustomer = customer
        this.showDeleteCustomerConfirmDialog = true
      },
      closeDeleteDialog: function () {
        this.showDeleteCustomerConfirmDialog = false
      },
      resetSearch: function () {
        this.searchTerm = ''
        this.searchCustomers(this.searchTerm)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Customers/Customers.vue